class Cookies {
	run() {
		this.cookieConsent();
	}

	cookieConsent() {
		window.start.init({
            Palette:"palette1",
            Mode:"banner bottom",
            Theme:"edgeless",
            Message:"Questo sito internet utilizza cookies per migliorare l'esperienza d'uso. Navigando ne autorizzi l'installazione in accordo con la",
            ButtonText:"<i class='icon-close'></i>",
            LinkText:"Cookie Policy.",
            Location:"/cookie-policy",
            Time:"5",})
	}
}

const cookies = new Cookies();
export default cookies;
